@file:OptIn(InternalResourceApi::class)

package inspection.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/inspection.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(593_966_191)
internal val Res.drawable.ic_add: DrawableResource by lazy {
      DrawableResource("drawable:ic_add", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-add.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_260_780_992)
internal val Res.drawable.ic_alert: DrawableResource by lazy {
      DrawableResource("drawable:ic_alert", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-alert.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(7_154_380)
internal val Res.drawable.ic_alert_triangle: DrawableResource by lazy {
      DrawableResource("drawable:ic_alert_triangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-alert-triangle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-565_723_776)
internal val Res.drawable.ic_archive: DrawableResource by lazy {
      DrawableResource("drawable:ic_archive", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-archive.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_131_593_481)
internal val Res.drawable.ic_arrow_down: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-arrow-down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_327_331_429)
internal val Res.drawable.ic_arrow_left: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-arrow-left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_567_785_306)
internal val Res.drawable.ic_arrow_left_line: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_left_line", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-arrow-left-line.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_023_065_870)
internal val Res.drawable.ic_arrow_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-arrow-right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(518_894_092)
internal val Res.drawable.ic_arrow_up: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-arrow-up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_674_150_297)
internal val Res.drawable.ic_attachment: DrawableResource by lazy {
      DrawableResource("drawable:ic_attachment", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-attachment.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_331_225_730)
internal val Res.drawable.ic_calendar: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-calendar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_609_456_680)
internal val Res.drawable.ic_camera: DrawableResource by lazy {
      DrawableResource("drawable:ic_camera", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-camera.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_309_847_466)
internal val Res.drawable.ic_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_702_025_940)
internal val Res.drawable.ic_check_circle: DrawableResource by lazy {
      DrawableResource("drawable:ic_check_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-check-circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_475_823_141)
internal val Res.drawable.ic_check_circle_outline: DrawableResource by lazy {
      DrawableResource("drawable:ic_check_circle_outline", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-check-circle-outline.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-569_217_797)
internal val Res.drawable.ic_close: DrawableResource by lazy {
      DrawableResource("drawable:ic_close", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-close.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_696_360_451)
internal val Res.drawable.ic_close_circle_fill: DrawableResource by lazy {
      DrawableResource("drawable:ic_close_circle_fill", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-close-circle-fill.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_030_734_510)
internal val Res.drawable.ic_connection_connected: DrawableResource by lazy {
      DrawableResource("drawable:ic_connection_connected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-connection-connected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_793_456_831)
internal val Res.drawable.ic_connection_disconnected: DrawableResource by lazy {
      DrawableResource("drawable:ic_connection_disconnected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-connection-disconnected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_057_064_120)
internal val Res.drawable.ic_connection_unknown: DrawableResource by lazy {
      DrawableResource("drawable:ic_connection_unknown", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-connection-unknown.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_390_786_750)
internal val Res.drawable.ic_download: DrawableResource by lazy {
      DrawableResource("drawable:ic_download", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-download.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(862_175_763)
internal val Res.drawable.ic_eye: DrawableResource by lazy {
      DrawableResource("drawable:ic_eye", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-eye.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(905_655_220)
internal val Res.drawable.ic_eye_off: DrawableResource by lazy {
      DrawableResource("drawable:ic_eye_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-eye-off.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_533_147_509)
internal val Res.drawable.ic_image: DrawableResource by lazy {
      DrawableResource("drawable:ic_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-image.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-442_913_404)
internal val Res.drawable.ic_inspection: DrawableResource by lazy {
      DrawableResource("drawable:ic_inspection", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-inspection.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_680_889_578)
internal val Res.drawable.ic_location: DrawableResource by lazy {
      DrawableResource("drawable:ic_location", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-location.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(406_865_553)
internal val Res.drawable.ic_logout: DrawableResource by lazy {
      DrawableResource("drawable:ic_logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-logout.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-874_684_839)
internal val Res.drawable.ic_menu: DrawableResource by lazy {
      DrawableResource("drawable:ic_menu", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-menu.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_996_773_384)
internal val Res.drawable.ic_more_horizontal: DrawableResource by lazy {
      DrawableResource("drawable:ic_more_horizontal", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-more-horizontal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(321_750_366)
internal val Res.drawable.ic_more_vertical: DrawableResource by lazy {
      DrawableResource("drawable:ic_more_vertical", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-more-vertical.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_819_186_960)
internal val Res.drawable.ic_notes: DrawableResource by lazy {
      DrawableResource("drawable:ic_notes", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-notes.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_733_686_624)
internal val Res.drawable.ic_pencil: DrawableResource by lazy {
      DrawableResource("drawable:ic_pencil", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-pencil.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-674_657_060)
internal val Res.drawable.ic_question: DrawableResource by lazy {
      DrawableResource("drawable:ic_question", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-question.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-960_094_961)
internal val Res.drawable.ic_search: DrawableResource by lazy {
      DrawableResource("drawable:ic_search", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-search.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(22_946_377)
internal val Res.drawable.ic_task: DrawableResource by lazy {
      DrawableResource("drawable:ic_task", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-task.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(479_488_470)
internal val Res.drawable.ic_template: DrawableResource by lazy {
      DrawableResource("drawable:ic_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-template.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_988_702_500)
internal val Res.drawable.ic_text: DrawableResource by lazy {
      DrawableResource("drawable:ic_text", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-text.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(698_433_760)
internal val Res.drawable.ic_time: DrawableResource by lazy {
      DrawableResource("drawable:ic_time", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-time.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_739_942_497)
internal val Res.drawable.ic_trash: DrawableResource by lazy {
      DrawableResource("drawable:ic_trash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-trash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-992_042_423)
internal val Res.drawable.ic_undo: DrawableResource by lazy {
      DrawableResource("drawable:ic_undo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-undo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(822_846_150)
internal val Res.drawable.ic_upload: DrawableResource by lazy {
      DrawableResource("drawable:ic_upload", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-upload.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-673_995_518)
internal val Res.drawable.ic_vessel: DrawableResource by lazy {
      DrawableResource("drawable:ic_vessel", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-vessel.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_716_349_001)
internal val Res.drawable.ic_warning_circle: DrawableResource by lazy {
      DrawableResource("drawable:ic_warning_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-warning-circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(7_154_380)
internal val Res.drawable.ic_warning_triangle: DrawableResource by lazy {
      DrawableResource("drawable:ic_warning_triangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic-warning-triangle.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_add", Res.drawable.ic_add)
  map.put("ic_alert", Res.drawable.ic_alert)
  map.put("ic_alert_triangle", Res.drawable.ic_alert_triangle)
  map.put("ic_archive", Res.drawable.ic_archive)
  map.put("ic_arrow_down", Res.drawable.ic_arrow_down)
  map.put("ic_arrow_left", Res.drawable.ic_arrow_left)
  map.put("ic_arrow_left_line", Res.drawable.ic_arrow_left_line)
  map.put("ic_arrow_right", Res.drawable.ic_arrow_right)
  map.put("ic_arrow_up", Res.drawable.ic_arrow_up)
  map.put("ic_attachment", Res.drawable.ic_attachment)
  map.put("ic_calendar", Res.drawable.ic_calendar)
  map.put("ic_camera", Res.drawable.ic_camera)
  map.put("ic_check", Res.drawable.ic_check)
  map.put("ic_check_circle", Res.drawable.ic_check_circle)
  map.put("ic_check_circle_outline", Res.drawable.ic_check_circle_outline)
  map.put("ic_close", Res.drawable.ic_close)
  map.put("ic_close_circle_fill", Res.drawable.ic_close_circle_fill)
  map.put("ic_connection_connected", Res.drawable.ic_connection_connected)
  map.put("ic_connection_disconnected", Res.drawable.ic_connection_disconnected)
  map.put("ic_connection_unknown", Res.drawable.ic_connection_unknown)
  map.put("ic_download", Res.drawable.ic_download)
  map.put("ic_eye", Res.drawable.ic_eye)
  map.put("ic_eye_off", Res.drawable.ic_eye_off)
  map.put("ic_image", Res.drawable.ic_image)
  map.put("ic_inspection", Res.drawable.ic_inspection)
  map.put("ic_location", Res.drawable.ic_location)
  map.put("ic_logout", Res.drawable.ic_logout)
  map.put("ic_menu", Res.drawable.ic_menu)
  map.put("ic_more_horizontal", Res.drawable.ic_more_horizontal)
  map.put("ic_more_vertical", Res.drawable.ic_more_vertical)
  map.put("ic_notes", Res.drawable.ic_notes)
  map.put("ic_pencil", Res.drawable.ic_pencil)
  map.put("ic_question", Res.drawable.ic_question)
  map.put("ic_search", Res.drawable.ic_search)
  map.put("ic_task", Res.drawable.ic_task)
  map.put("ic_template", Res.drawable.ic_template)
  map.put("ic_text", Res.drawable.ic_text)
  map.put("ic_time", Res.drawable.ic_time)
  map.put("ic_trash", Res.drawable.ic_trash)
  map.put("ic_undo", Res.drawable.ic_undo)
  map.put("ic_upload", Res.drawable.ic_upload)
  map.put("ic_vessel", Res.drawable.ic_vessel)
  map.put("ic_warning_circle", Res.drawable.ic_warning_circle)
  map.put("ic_warning_triangle", Res.drawable.ic_warning_triangle)
}
